import { defaultEnvironment } from './environment.default';

export const environment = {
  ...defaultEnvironment,
  production: true,
  mceApiUrl: "https://test.api.mycableengineering.com/",
};
